import React, { useContext, useEffect, useState } from "react";
import Tooltip from '@mui/material/Tooltip';

import { Context } from "../../Provider";
import { theme } from "../../../../theme";
import DocumentsTypes from "./documents/DocumentsTypes";
import AddNewServiceCategoriesAndTypes from "./components/AddNewServiceCategoriesAndTypes";
import { fetchCheckFtmExpiredCertificate } from "../../service";

const Skills = () => {
    const { state } = useContext(Context);
    const { ftm_skills: ftmSkills, ftm_id: ftmId } = state?.ftm;

    const [checkingFtmExpiredCertificateList, setCheckingFtmExpiredCertificateList] = useState(null);

    const [showDocumentsTypes, setShowDocumentsTypes] = useState(false);
    const [selectedSkill, setSelectedSkill] = useState(null);
    const [selectedSubSkill, setSelectedSubSkill] = useState(null);
    const [addNewServiceCategoriesAndTypesModal, setAddNewServiceCategoriesAndTypesModal] = useState(false);

    const handelShowAddNewServiceCategoriesAndTypesModal = () =>
        setAddNewServiceCategoriesAndTypesModal(true);
    const handelCloseAddNewServiceCategoriesAndTypesModal = () =>
        setAddNewServiceCategoriesAndTypesModal(false);

    const handelShowDocumentsTypes = () => setShowDocumentsTypes(true);
    const handelCloseDocumentsTypes = () => setShowDocumentsTypes(false);

    const selectSkill = ({ skill, subSkill }) => {
        setSelectedSkill(skill);
        setSelectedSubSkill(subSkill);
        handelShowDocumentsTypes();
    };

    // 🔎 Helper: find expired info by subSkill id
    const getExpiredInfo = (subSkillId) => {
        if (!checkingFtmExpiredCertificateList) return null;

        return checkingFtmExpiredCertificateList.find(
            (item) => item.skill_id === subSkillId
        );
    };

    useEffect(() => {
        const getCheckFtmExpiredCertificate = async () => {
            try {
                const response = await fetchCheckFtmExpiredCertificate(ftmId);
                if (response.status === "Success") {
                    setCheckingFtmExpiredCertificateList(response.data);
                }
            } catch (error) {
                console.log(error);
            }
        };

        getCheckFtmExpiredCertificate();
    }, [ftmId]);

    return (
        <div className="card h-100">
            <div className="card-header pb-0 p-3">
                <div className="d-flex justify-content-between">
                    <h6 className="mb-0">Service categories &amp; types</h6>
                    <button
                        type="button"
                        className="btn btn-icon-only mb-0 ms-2 btn-sm d-flex align-items-center justify-content-center"
                        onClick={handelShowAddNewServiceCategoriesAndTypesModal}
                    >
                        <i className="material-icons" style={{ fontSize: "25px" }}>add_box</i>
                    </button>
                </div>
            </div>

            <div className="card-body p-3">
                <div
                    style={{
                        height: "600px",
                        overflow: "auto",
                        overflowX: "hidden",
                    }}
                >
                    {ftmSkills.map((skill) => (
                        <React.Fragment key={skill.skill_id ?? skill.skill_name}>
                            <div className="row align-items-center mb-1">
                                <div className="col-1">
                                    <i
                                        className={`material-icons text-${theme.main}`}
                                        aria-hidden="true"
                                    >
                                        {skill.skill_web_app_icon}
                                    </i>
                                </div>
                                <div className="col-11 ps-0">
                                    <h6 className="mb-1 text-uppercase text-dark">
                                        {skill.skill_name}
                                    </h6>
                                </div>
                            </div>

                            <ul className="list-unstyled mx-auto">
                                {skill.subSkills?.map((sub) => {
                                    const expired = getExpiredInfo(sub.sub_skill_id);
                                    const hasExpired =
                                        expired?.is_have_expired_skill_docs ||
                                        expired?.is_have_expired_sub_skill_docs;

                                    return (
                                        <li
                                            key={sub.sub_skill_id ?? sub.sub_skill_name}
                                            className="d-flex hover-row px-2 pt-2"
                                            onClick={() => selectSkill({
                                                skill: {
                                                    skill_id: skill.skill_id,
                                                    skill_name: skill.skill_name,
                                                    skill_web_app_icon: skill.skill_web_app_icon,
                                                },
                                                subSkill: {
                                                    sub_skill_id: sub.sub_skill_id,
                                                    sub_skill_name: sub.sub_skill_name,
                                                    skill_is_approve: sub.skill_is_approve
                                                }
                                            })}
                                        >
                                            <h6 className="text-dark fw-bold text-sm">
                                                {sub.sub_skill_name}
                                            </h6>

                                            {sub.skill_is_approve === 1 && (
                                                <div className="ms-auto text-sm mt-0">
                                                    <i
                                                        className={`material-icons opacity-10 text-${theme.main}`}
                                                        aria-label="verified"
                                                    >
                                                        verified
                                                    </i>
                                                </div>
                                            )}

                                            {hasExpired && (
                                                <Tooltip title={`Some documents validity has ended.`} arrow placement="right">
                                                    <div className="ms-auto text-sm mt-0">
                                                        <i
                                                            className={`material-icons opacity-10 text-danger`}
                                                            aria-label="file_save_off"
                                                        >
                                                            report_off
                                                        </i>
                                                    </div>
                                                </Tooltip>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        </React.Fragment>
                    ))}
                </div>
            </div>

            <DocumentsTypes
                show={showDocumentsTypes}
                handleClose={handelCloseDocumentsTypes}
                ftmId={ftmId}
                skill={selectedSkill}
                subSkill={selectedSubSkill}
            />

            <AddNewServiceCategoriesAndTypes
                show={addNewServiceCategoriesAndTypesModal}
                handleClose={handelCloseAddNewServiceCategoriesAndTypesModal}
            />
        </div>
    );
};

export default Skills;